// extracted by mini-css-extract-plugin
module.exports = {"slide":"TopSlider-module--slide--Gb13Z"};